import axios from "../utils/axios";
import {StartResponse, MessageResponse, CloseResponse} from "@/types/chatTypes";

export async function startConversation(): Promise<StartResponse>{
    const response = await axios.post("/ai/conversation");
    return response.data
}

//Tour Agentico Chat
export async function sendMessage(conversationId: string, message: string): Promise<MessageResponse>{
    const response = await axios.post(`/tour/${conversationId}/message`, {message});
    return response.data
}

// Vecchio Agente Chat
export async function sendConversationalMessage(conversationId: string, message: string): Promise<MessageResponse>{
    const response = await axios.post(`/ai/send_message/${conversationId}`, {message});
    return response.data
}

/**
export async function sendMessage(conversationId: string, message: string): Promise<MessageResponse>{
    const response = await axios.post(`/ai/send_message/${conversationId}`, {message});
    return response.data
}*/

export async function deleteConversation(conversationId: string): Promise<CloseResponse>{
    const response = await axios.delete(`/ai/conversation/${conversationId}`);
    return response.data
}